import { FETCH_ALL_COMMITTEE_MEETINGS } from '../actions';

export default ( state = {}, action ) => {

	switch ( action.type ) {

		case FETCH_ALL_COMMITTEE_MEETINGS:
			if ( Object.keys( action.payload ).length === 0 ) {
				return {};
			}
			let upcoming_meetings_arr = (typeof state.upcoming_meetings === 'undefined' || typeof action.payload.upcoming_meetings !== 'undefined'
			                            )
				? action.payload.upcoming_meetings
				: state.upcoming_meetings;

			let past_meetings_arr = (typeof state.past_meetings === 'undefined' || typeof action.payload.past_meetings !== 'undefined'
			                        )
				? action.payload.past_meetings
				: state.past_meetings;

			let total_past_meetings = (typeof state.total_past_meetings === 'undefined' || typeof action.payload.total_past_meetings !== 'undefined'
			                          )
				? action.payload.total_past_meetings
				: state.total_past_meetings;
			let total_upcoming_meetings = (typeof state.total_upcoming_meetings === 'undefined' || typeof action.payload.total_upcoming_meetings !== 'undefined'
			                              )
				? action.payload.total_upcoming_meetings
				: state.total_upcoming_meetings;
			return {
				upcoming_meetings         : [
					...upcoming_meetings_arr
				],
				past_meetings             : [
					...past_meetings_arr
				],
				total_upcoming_meetings   : parseInt( total_upcoming_meetings ),
				total_past_meetings       : parseInt( total_past_meetings )
			};
			break;
	}
	return state;
}